module.exports = __webpack_public_path__ + "static/media/static-3-Ca.c1da3e0f.jpg";